import 'bootstrap/dist/css/bootstrap.css';
import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, HashRouter, Navigate, json } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import config from './appURL.json';
import { jwtDecode } from 'jwt-decode';
import './Fonts/Fonts.Lato.css';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

const RootComponent = () => {
  const [authenticated, setAuthenticated] = useState(false);
  const [checkingAuthentication, setCheckingAuthentication] = useState(true);

  const fetchUserInfo = async (token) => {
    try {
      const response = await fetch(`${config.API_IDENTITY_GetUserInfo}token=${token}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        console.error('Failed to fetch data:', response.status);
        return;
      }

      const data = await response.json();
      return data.User.User;
    } catch (error) {
      console.log(error);
    }
  };

  const fetchUserPermission = async (token) => {
    try {
      const response = await fetch(`${config.API_IDENTITY_GetUserPermission}token=${token}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        console.error('Failed to fetch data:', response.status);
        return;
      }

      const data = await response.json();
      return data.permission;
    } catch (error) {
      console.log(error);
    }
  };

  const encodeBase64 = (str) => {
    return window.btoa(unescape(encodeURIComponent(str)));
  };

  useEffect(() => {
    const checkAuthentication = async () => {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const tokenFromURL = urlSearchParams.get('token');
      const token = tokenFromURL || localStorage.getItem('token');

      if (!token) {
        // If the token is not present, redirect to the login page
        const currentPath = window.location.href;
        localStorage.setItem('returnUrl', window.location.pathname);
        window.location.href = `${config.API_IDENTITY_Authorize}/Identity/Account/Login?returnUrl=${encodeURIComponent(currentPath)}`;
        return;
      }

      try {
        // Remove the token from the URL
        window.history.replaceState({}, document.title, window.location.pathname);
        // Decode the token without verifying signature
        const tokenPayload = JSON.parse(atob(token.split('.')[1]));

        // Check token expiration
        const currentTimestamp = Math.floor(Date.now() / 1000);

        if (tokenPayload.exp && tokenPayload.exp < currentTimestamp) {
          // Token has expired, redirect to the login page
          const currentPath = window.location.href;
          localStorage.setItem('returnUrl', window.location.pathname);
          window.location.href = `${config.API_IDENTITY_Authorize}/Identity/Account/Login?returnUrl=${encodeURIComponent(currentPath)}`;
          return;
        }

        const decodedClaims = jwtDecode(token);
        const decodedIdentifiers = JSON.parse(atob(decodedClaims.Identifiers)).Data;
        
        const user = await fetchUserInfo(token);
        const permission = await fetchUserPermission(token);
        if (user && permission) {
          const UserData = {
            UserInfo: { Data: user },
            UserPermission: { Data: permission },
            CodeList: decodedIdentifiers
          };
          const UserDataJSON = JSON.stringify(UserData);
          const UserDataBase64 = encodeBase64(UserDataJSON);
          localStorage.setItem('UserData', UserDataBase64);
        }

        localStorage.setItem('token', token);

        setAuthenticated(true);

        const returnUrl = localStorage.getItem('returnUrl');
        if (returnUrl) {
          window.location.href = returnUrl;
          localStorage.removeItem('returnUrl');
        }

      } catch (error) {

        // Handle the error as needed
      }
      finally {
        setCheckingAuthentication(false);
      }
    };

    checkAuthentication();
  }, []);

  if (checkingAuthentication) {
    return <div>Loading...</div>;
  }

  // If not authenticated, redirect to the login page
  if (!authenticated) {
    const currentPath = window.location.href;
    localStorage.setItem('returnUrl', window.location.pathname);
    return <Navigate to={`${config.API_IDENTITY_Authorize}/Identity/Account/Login?returnUrl=${encodeURIComponent(currentPath)}`} />;
  }

  return (
    <HashRouter>
      <App />
    </HashRouter>
  );
};

root.render(<RootComponent />);
reportWebVitals();